import { Modal } from "react-bootstrap";
import modalimg from "../image/itemnotfound.png";
const ItemNotFound = ({
  open = false,
  onClose = () => {},
  productCode = "",
  onCloseAddProduct = () => {},
}) => {
  return (
    <Modal
      show={open}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={onClose}
    >
      <Modal.Body style={{ padding: 0 }}>
        <div style={{ textAlign: "center", padding: 0 }}>
          <div className="height12"></div>
          <div className="height12"></div>
          <img src={modalimg} width="30px" height="24px" alt="" />
          <div className="height12"></div>
          <p className="notfoundtext">Item Not Found</p>
          <p className="scannedtext">Scanned Item Code : {productCode}</p>
          <p className="addItemalert">
            Do you want to add this item to your inventory
          </p>
          <div className="height12"></div>
          <div className="height12"></div>
          <div className="rowButton">
            <button
              onClick={() => {
                onClose();
              }}
              className="rightborder"
            >
              Cancel
            </button>
            <button
              onClick={() => {
                onCloseAddProduct();
              }}
            >
              Add Item
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ItemNotFound;
